var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?[_c('b-row',[_c('div',{staticClass:"col-12"},[_c('b-card',[_c('b-card-title',{attrs:{"title-tag":"h5","title":`Bookings for ${_vm.marshal.name}`}}),_vm._v(" "),_c('b-card-body',[_c('div',{attrs:{"id":"bookings-table"}})])],1)],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }